import { store } from 'src/_helpers'
import { DirectMessagingActions } from 'src/_actions'

export const sendMsg = (msg) => {
  console.log(msg)
}
export const addMsg = (msg) => {
  store.dispatch(DirectMessagingActions.addMsg(msg))
}
export const addBEMsg = (msg) => {
  store.dispatch(DirectMessagingActions.addBEMsg(msg))
}
export const initFeClient = (msg) => {
  store.dispatch(DirectMessagingActions.addClient(msg))
}
export const initBEClient = (msg) => {
  store.dispatch(DirectMessagingActions.addClient(msg))
}
export const initGroup = (data) => {
  store.dispatch(DirectMessagingActions.initGroup(data))
}
export const getCurrentClientId = () => {
  return store.getState().DirectMessaging?.client_id
}
export const newGroup = (data) => {
  store.dispatch(DirectMessagingActions.newGroup(data))
}
